// extracted by mini-css-extract-plugin
export default {"tag":"previewItem_tag__l4B29","meta":"previewItem_meta__jBBMA","date":"previewItem_date__p9HCj","new":"previewItem_new__BlZU-"};